import { useNavigate } from "react-router-dom"
import styled from "styled-components"

import { ReactComponent as BackIcon } from "assets/svg/icon-arrow-left.svg"

import { ContentWrapper } from "components/common/ContentWrapper"
import MessageTemplatesList from "components/common/MessageTemplatesList"
import { ButtonNew } from "components/form/ButtonNew"

import styles from "../../../assets/scss/index.module.scss"

const BackButton = styled(ButtonNew)`
  margin-top: -48px;
  position: relative;
`

const StyledContentWrapper = styled.div`
  background: $colorWhite;
  overflow-x: scroll;
  min-height: calc(100vh - 190px);
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 1200px) {
    flex-wrap: wrap;
  }
`

const SectionWrapper = styled.div`
  width: calc(50% - 12px);
  max-height: 550px;

  @media only screen and (max-width: 1200px) {
    width: 100%;

    &:first-child {
      margin-bottom: 24px;
    }
  }
`

interface MessageTemplateContainerProps {
  title: string
  children: React.ReactNode
}

const MessageTemplateContainer = ({ title, children }: MessageTemplateContainerProps) => {
  const navigate = useNavigate()

  return (
    <ContentWrapper title={title}>
      <nav className={styles.tableNavWrapper}>
        <div></div>
        <BackButton onClick={() => navigate("/messages2/center")} color="greyBordered">
          <BackIcon />
          Back
        </BackButton>
      </nav>
      <StyledContentWrapper>
        <SectionWrapper>{children}</SectionWrapper>
        <SectionWrapper>
          <MessageTemplatesList />
        </SectionWrapper>
      </StyledContentWrapper>
    </ContentWrapper>
  )
}

export default MessageTemplateContainer
